import type { Monaco } from '@monaco-editor/react';

export function setupMonacoThemes(monaco: Monaco) {
  // Define custom dark theme for Mantine (matches Mantine TextField background)
  monaco.editor.defineTheme('mantine-dark', {
    base: 'vs-dark',
    inherit: true,
    rules: [],
    colors: {
      'editor.background': '#2e2e2e',
    },
  });
}
